import { z } from 'zod';
import { Regione } from '../enums';
import { capSchema } from './primitives';

/**
 * Indirizzo: value-object condiviso da sede legale, sedi operative cliente e
 * anagrafica partner. Vive in `common` perché è trasversale a più slice, non
 * di proprietà di un singolo mondo.
 */
export const indirizzoSchema = z.object({
  via: z.string().trim().min(1).max(200),
  civico: z.string().trim().max(20).optional(),
  cap: capSchema,
  comune: z.string().trim().min(1).max(120),
  provincia: z.string().trim().length(2).toUpperCase(),
  regione: Regione,
});
export type Indirizzo = z.infer<typeof indirizzoSchema>;
